export default __webpack_public_path__ + "static/media/password.615b8cf8.svg";